import { useEffect, useState } from "react";
import { About } from "../../pages/AboutPage/index";
// FRAGMENTS section is temporarily on hold — page import commented out so its
// code (and the 3D model fetches it triggers) never loads in the background.
// import { FragmentsPage } from "../../pages/FragmentsPage/index";
import "./style.css";

type SubpagePanel = "about" | "contact" | "fragments";

const getPanelFromDom = (): SubpagePanel => {
  const raw = document.documentElement.dataset.subpage;
  if (raw === "contact") return "contact";
  // "fragments" intentionally falls through to "about" while the section is hidden.
  return "about";
};

export const Subpage = () => {
  const [panel, setPanel] = useState<SubpagePanel>(getPanelFromDom);
  const [contentKey, setContentKey] = useState(0);

  useEffect(() => {
    const onPanelChange = (event: Event) => {
      const custom = event as CustomEvent<{ subpage?: string }>;
      const next = custom.detail?.subpage;
      if (next === "contact") setPanel("contact");
      // "fragments" intentionally falls through to "about" while the section is hidden.
      else setPanel("about");
      setContentKey((current) => current + 1);
    };

    const html = document.documentElement;
    let previousState = html.dataset.pageState;
    const stateObserver = new MutationObserver(() => {
      const nextState = html.dataset.pageState;

      if (nextState === "home" && previousState === "transitioning-home") {
        setPanel("about");
        setContentKey((current) => current + 1);
      }

      previousState = nextState;
    });

    window.addEventListener("subpage-change", onPanelChange as EventListener);
    stateObserver.observe(html, {
      attributes: true,
      attributeFilter: ["data-page-state"],
    });

    return () => {
      window.removeEventListener(
        "subpage-change",
        onPanelChange as EventListener,
      );
      stateObserver.disconnect();
    };
  }, []);

  // FRAGMENTS section is temporarily hidden — panel never resolves to
  // "fragments" above, so this always renders About/Contact for now.
  const aboutMode = panel === "contact" ? "contact" : "about";

  return (
    <section
      className={`subpage subpage--panel-${panel}`}
      aria-label="Subpage content"
      data-subpage="main"
    >
      <About mode={aboutMode} key={contentKey} />
    </section>
  );
};
